var exports = {
  "k": "x127c5a35--e0722c--container",
};

module.exports = exports;
